// Error events that contain the following terms in their exception values
// will be discarded in beforeSend hook of Sentry client
// (https://develop.sentry.dev/sdk/event-payloads/)
const beforeSendSentry = function(event) {
  const exceptionValueMatched = [
    'messaging/permission-blocked', // Users have the browser set up to block messaging API
    'Avoided redundant navigation', // Vue router rejects a navigation promise and there's no way to handle it when it occurs in `<router-link>`
    '(chunk-vendors)' // Users with previous version of app in cache make requests to vendor chunk that is not on the server anymore
  ].some(term => {
    if (!event.exception) return false;

    if (Array.isArray(event.exception)) {
      if (event.exception.length === 1) {
        return event.exception[0].value.includes(term);
      } else {
        // Chained exceptions are left alone
        // https://develop.sentry.dev/sdk/event-payloads/exception/#examples
        return false;
      }
    }

    if (Array.isArray(event.exception.values)) {
      if (event.exception.values.length === 1) {
        return event.exception.values[0].value.includes(term);
      } else {
        // Chained exceptions are left alone
        // https://develop.sentry.dev/sdk/event-payloads/exception/#examples
        return false;
      }
    }

    return false;
  });

  if (exceptionValueMatched) {
    return null;
  }

  return event;
};

module.exports = {
  beforeSendSentry
};

// This is needed for import to work ini
module.exports.default = beforeSendSentry;
